import { Result } from '@standardnotes/domain-core';
export class GetOwnedSharedVaults {
    constructor(_getSharedVaults, _isVaultOwnwer) {
        this._getSharedVaults = _getSharedVaults;
        this._isVaultOwnwer = _isVaultOwnwer;
    }
    execute() {
        const sharedVaults = this._getSharedVaults.execute().getValue();
        const ownedVaults = sharedVaults.filter((vault) => {
            return this._isVaultOwnwer.execute(vault).getValue();
        });
        return Result.ok(ownedVaults);
    }
}
